import SvgIcon from '@/pages/home/components/SvgIcon';
import React, { useEffect, useState } from 'react';
import { Bubble, Button, Modal, notification } from 'tea-component';
import SubscribeModal from './subscribe-modal';
import {
  requestInsightSubscribeInfo,
  setReportInsightUnsubscribe,
} from '@/pages/opinion/services';
import { useIntl } from 'umi';
import './index.scss';

// /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/.test("2921855939@qq.com")
// console.log(/([a-zA-Z0-9])+@([a-zA-Z0-9])+\.([0-9a-zA-Z]+)$/.test("2921855939@qq.com"));

export default function Subscribe({ gameInfo, wholeGameInfo, userInfo }: any) {
  // 模拟 Subscribe 按钮
  const [subscribe, setSubscribe] = useState<{
    emails: Array<string>;
    edition_unified_id: string;
    entity_type: string;
    id_type: string;
    title: string;
    user_name: string;
    create_time: string;
  } | null>(null);

  const [isModal, setIsModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const { formatMessage } = useIntl();
  const clickSubscribeBtn = async () => {
    // 已订阅
    if (subscribe !== null) {
      setIsModal(false);

      const yes = await Modal.confirm({
        className: 'dbo-unsubscribed-text-tip',
        message: formatMessage({ id: 'Unsubscribe' }),
        description: formatMessage({ id: 'Are you sure to unsubscribed ？' }),
        okText: formatMessage({ id: 'Confirm' }),
        cancelText: formatMessage({ id: 'Cancel' }),
      });
      if (yes) {
        setLoading(true);
        setReportInsightUnsubscribe(gameInfo)
          .then(() => {
            notification.success({
              description: formatMessage({ id: 'Unsubscribe successful.' }),
            });
            setSubscribe(null);
          })
          .catch(() => {
            notification.error({
              description: formatMessage({ id: 'Unsubscribe failure' }),
            });
          })
          .finally(() => {
            setLoading(false);
          });
      }
    } else {
      setIsModal(true);
    }
  };

  const getInsightSubscribeInfo = () => {
    setLoading(true);
    if (!gameInfo.edition_unified_id) return;
    requestInsightSubscribeInfo(gameInfo)
      .then((data: any) => {
        const { subscribe_stats } = data || {};
        if (subscribe_stats === '1') {
          setSubscribe(data);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (gameInfo) {
      getInsightSubscribeInfo();
    }
  }, [gameInfo]);

  const bubbleText = () => {
    if (subscribe === null) return null;
    const { title, user_name, create_time } = subscribe || {};
    return (
      <div className="tips-box">
        <p className="tips-item">
          <label className="title">
            {formatMessage({ id: 'Sending Mailbox' })}:
          </label>
          <label className="des">databrain_noreply@levelinfinite.com</label>
        </p>
        <p className="tips-item">
          <label className="title">
            {formatMessage({ id: 'Email Title' })}:
          </label>
          <label className="des">{title}</label>
        </p>
        <p className="tips-item">
          <label className="title">
            {formatMessage({ id: 'Subscriber' })}:
          </label>
          <label className="des">{user_name}</label>
        </p>
        <p className="tips-item">
          <label className="title">
            {formatMessage({ id: 'Subscription time' })}:
          </label>
          <label className="des">{create_time}</label>
        </p>
      </div>
    );
  };

  return (
    <>
      <Bubble
        overlayClassName="dbo-subscribe-box-bubble"
        placement="left"
        content={bubbleText()}
        dark
        closeOnScroll
      >
        <Button
          type="text"
          className={`dbo-report-right-btn ns-btn--border ${
            subscribe ? 'action' : ''
          }`}
          disabled={loading}
          onClick={clickSubscribeBtn}
        >
          <SvgIcon
            type={subscribe !== null ? 'flag-succeed' : 'flag-plus'}
            className={
              subscribe !== null
                ? 'dbo-report-icon-action'
                : 'dbo-report-right-icon'
            }
          />
          {formatMessage({
            id: subscribe !== null ? 'Subscribed' : 'Subscribe',
          })}
        </Button>
      </Bubble>

      {isModal && (
        <SubscribeModal
          visible={isModal}
          gameInfo={gameInfo}
          wholeGameInfo={wholeGameInfo}
          successCallback={getInsightSubscribeInfo}
          close={() => setIsModal(false)}
        />
      )}
    </>
  );
}
